"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivateOfferSchema = exports.RewardGenerationBasicJobData = exports.DevicePatchBody = exports.SubmitSurveyResponseResponse = exports.MmpLinkBody = void 0;
const zod_1 = require("zod");
const types_1 = require("../types");
exports.MmpLinkBody = types_1.MmpClickIds.omit({
    createdAt: true,
    lastClickedAt: true,
    clickTimestamp: true,
    appType: true,
});
exports.SubmitSurveyResponseResponse = zod_1.z.object({
    rewards: types_1.ResourceRewards,
    survey: types_1.SurveyInstance,
});
exports.DevicePatchBody = types_1.Device.partial();
// Zerg reward generation
exports.RewardGenerationBasicJobData = zod_1.z.object({
    jobType: zod_1.z.literal('BASIC'),
    appType: types_1.AppTypeEnum,
    subSourceId: zod_1.z.string(),
    userId: zod_1.z.string(),
    completedTaskId: zod_1.z.string(),
    unlockedTaskIds: zod_1.z.array(zod_1.z.string()),
    activatedOfferId: zod_1.z.string(),
});
exports.ActivateOfferSchema = zod_1.z.object({
    campaignId: zod_1.z.string(),
    offerListItemId: zod_1.z.string(),
    mmpClickDetails: exports.MmpLinkBody,
    clientPlatform: zod_1.z.string(),
});
